import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Shared/Sidebar';
import Icon from '../Shared/Icons';
import { useAuth } from '../../context/AuthContext';
import { fetchClubs, fetchReports, resolveAuthorName } from '../../utils/programData';
import {
  fetchPlayers, savePlayer, deletePlayer,
  fetchEvents, saveEvent, deleteEvent,
  fetchGames, addGame, deleteGame,
  fetchPeriods, computePeriod, publishPeriod, recomputeAll,
  fetchCoaches, saveCoach, deleteCoach, computeCoachRecord,
} from '../../utils/ifrData';
import { periodKeyOf, periodLabel, isActive } from '../../utils/ifr';
import { PLAYER_TITLES, COACH_TITLES, titleByCode } from '../../config/ifrTitles';
import { RATING_CATEGORIES, categoryInfo } from '../../config/ratingCategories';
import { groupByClub } from '../../utils/playerSearch';
import { RS, TitleBadge } from './ratingUI';

// Chaguo za <option> kwa mchezaji — zimepangwa kwa club (A-Z) kisha jina
// (A-Z) ndani ya kila club, kama inavyotakiwa kila mahali mtu anapochaguliwa.
function PlayerOptions({ players, suffix }) {
  return groupByClub(players).map(group => (
    <optgroup key={group.clubName} label={group.clubName}>
      {group.members.map(p => (
        <option key={p.id} value={p.id}>
          {p.fullName}{suffix ? suffix(p) : ''}
        </option>
      ))}
    </optgroup>
  ));
}

const TABS = [
  { k: 'players', l: 'Wachezaji' },
  { k: 'events', l: 'Matukio' },
  { k: 'publish', l: 'Kuchapisha' },
  { k: 'coaches', l: 'Makocha' },
];

export default function RatingAdmin() {
  const { currentUser, userRole } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('players');
  const [players, setPlayers] = useState([]);
  const [events, setEvents] = useState([]);
  const [clubs, setClubs] = useState([]);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const [ps, evs, cs] = await Promise.all([fetchPlayers(), fetchEvents(), fetchClubs()]);
      setPlayers(ps.sort((a, b) => (b.ifr || 0) - (a.ifr || 0)));
      setEvents(evs);
      setClubs(cs);
    } catch (e) { console.error(e); setErr('Imeshindikana kupakia data.'); }
  }

  function flash(m) { setMsg(m); setTimeout(() => setMsg(''), 3500); }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#F6F4EE', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: '26px 20px 60px', width: '100%' }}>

        <h1 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: '25px', color: '#14452F', margin: 0 }}>
          Usimamizi wa IFR
        </h1>
        <p style={{ fontSize: '13px', color: '#6B7280', marginTop: '6px', marginBottom: '18px', lineHeight: 1.7 }}>
          Rating rasmi ya Iyanna Foundation. Kila kitu unachofanya hapa kinaonekana
          hadharani na kinaweza kuhesabiwa upya wakati wowote.
        </p>

        <div style={{ display: 'flex', gap: '7px', marginBottom: '16px', overflowX: 'auto' }}>
          {TABS.map(t => (
            <button key={t.k} onClick={() => setTab(t.k)} style={{
              whiteSpace: 'nowrap', padding: '10px 17px', borderRadius: '99px', cursor: 'pointer',
              border: `1px solid ${tab === t.k ? '#14452F' : '#E8E4DA'}`,
              background: tab === t.k ? '#14452F' : '#fff',
              color: tab === t.k ? '#fff' : '#6B7280',
              fontSize: '12.5px', fontWeight: 700, fontFamily: 'inherit',
            }}>{t.l}</button>
          ))}
        </div>

        {msg && <div style={RS.ok}>{msg}</div>}
        {err && <div style={RS.err}>{err}</div>}

        {tab === 'players' && (
          <PlayersTab players={players} clubs={clubs} reload={load} flash={flash} setErr={setErr} isAdmin={userRole === 'admin'} />
        )}
        {tab === 'events' && (
          <EventsTab events={events} players={players} clubs={clubs} reload={load} flash={flash} setErr={setErr} isAdmin={userRole === 'admin'} navigate={navigate} />
        )}
        {tab === 'publish' && (
          <PublishTab players={players} events={events} reload={load} flash={flash} setErr={setErr}
            currentUser={currentUser} isAdmin={userRole === 'admin'} />
        )}
        {tab === 'coaches' && (
          <CoachesTab players={players} clubs={clubs} flash={flash} setErr={setErr} isAdmin={userRole === 'admin'} />
        )}

      </div>
    </div>
  );
}

// ══ WACHEZAJI ═════════════════════════════════════════════════════════
const EMPTY_PLAYER = { fullName: '', dob: '', gender: '', clubId: '', clubName: '', school: '' };

function PlayersTab({ players, clubs, reload, flash, setErr, isAdmin }) {
  const [form, setForm] = useState(EMPTY_PLAYER);
  const [editing, setEditing] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [search, setSearch] = useState('');

  function ch(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function submit() {
    if (!form.fullName.trim()) { setErr('Andika jina kamili.'); return; }
    setBusy(true); setErr('');
    try {
      const club = clubs.find(c => c.id === form.clubId);
      await savePlayer({ ...form, clubName: club?.name || '', nameLower: form.fullName.toLowerCase() }, editing);
      flash(editing ? 'Mchezaji amebadilishwa.' : 'Mchezaji amesajiliwa.');
      setForm(EMPTY_PLAYER); setEditing(null); setShow(false); reload();
    } catch (e) { console.error(e); setErr('Imeshindikana kuhifadhi.'); }
    setBusy(false);
  }

  async function remove(p) {
    if (p.established) { setErr('Huwezi kufuta mchezaji mwenye rating rasmi — historia lazima ibaki.'); return; }
    if (!window.confirm(`Futa ${p.fullName}?`)) return;
    try { await deletePlayer(p.id); reload(); } catch (e) { console.error(e); }
  }

  const list = players.filter(p => !search.trim()
    || (p.fullName || '').toLowerCase().includes(search.toLowerCase()));

  return (
    <>
      <div style={{ display: 'flex', gap: '9px', marginBottom: '14px' }}>
        <input style={{ ...RS.input, flex: 1 }} placeholder="Tafuta jina..."
          value={search} onChange={e => setSearch(e.target.value)} />
        <button style={{ ...RS.btn, padding: '12px 18px' }}
          onClick={() => { setShow(!show); setEditing(null); setForm(EMPTY_PLAYER); }}>
          {show ? 'Funga' : '+ Sajili'}
        </button>
      </div>

      {show && (
        <div style={RS.card}>
          <h2 style={RS.h2}>{editing ? 'Badilisha mchezaji' : 'Sajili mchezaji rasmi'}</h2>
          <label style={RS.label}>Jina kamili *</label>
          <input style={{ ...RS.input, marginBottom: '14px' }} value={form.fullName}
            onChange={e => ch('fullName', e.target.value)} />

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 140px' }}>
              <label style={RS.label}>Tarehe ya kuzaliwa</label>
              <input type="date" style={{ ...RS.input, marginBottom: '14px' }} value={form.dob}
                onChange={e => ch('dob', e.target.value)} />
            </div>
            <div style={{ flex: '1 1 120px' }}>
              <label style={RS.label}>Jinsia</label>
              <select style={{ ...RS.input, marginBottom: '14px' }} value={form.gender}
                onChange={e => ch('gender', e.target.value)}>
                <option value="">—</option>
                <option value="Me">Me</option>
                <option value="Ke">Ke</option>
              </select>
            </div>
          </div>
          <div style={{ fontSize: '11.5px', color: '#6B7280', marginTop: '-6px', marginBottom: '14px', lineHeight: 1.6 }}>
            Tarehe ya kuzaliwa ni muhimu — vijana chini ya 18 wana K kubwa zaidi.
          </div>

          <label style={RS.label}>Club</label>
          <select style={{ ...RS.input, marginBottom: '14px' }} value={form.clubId}
            onChange={e => ch('clubId', e.target.value)}>
            <option value="">— Hana club —</option>
            {clubs.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>

          <label style={RS.label}>Shule / eneo</label>
          <input style={{ ...RS.input, marginBottom: '18px' }} value={form.school}
            onChange={e => ch('school', e.target.value)} />

          <button style={{ ...RS.btn, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
            {busy ? 'Inahifadhi…' : editing ? 'Hifadhi' : 'Sajili'}
          </button>
        </div>
      )}

      {list.length === 0 ? (
        <div style={RS.empty}>Bado hakuna mchezaji aliyesajiliwa kwenye IFR.</div>
      ) : list.map(p => (
        <div key={p.id} style={{ ...RS.row, cursor: 'default' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexWrap: 'wrap' }}>
              {p.title && <TitleBadge code={p.title} />}
              <span style={RS.name}>{p.fullName}</span>
            </div>
            <div style={RS.meta}>
              {p.clubName || p.school || '—'} · michezo {p.gamesRated || 0}
              {!p.established && ' · bado hana rating'}
              {p.established && !isActive(p.lastActivePeriod, periodKeyOf()) && ' · hana shughuli'}
            </div>
          </div>
          <div style={{ textAlign: 'right', marginRight: '8px' }}>
            <div style={RS.rating}>{p.established ? p.ifr : '—'}</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <button style={{ ...RS.btnGhost, padding: '5px 11px', fontSize: '11px' }}
              onClick={() => { setForm({ ...EMPTY_PLAYER, ...p }); setEditing(p.id); setShow(true); window.scrollTo(0, 0); }}>
              Hariri
            </button>
            {isAdmin && !p.established && (
              <button style={{ ...RS.btnGhost, padding: '5px 11px', fontSize: '11px', color: '#DC2626' }}
                onClick={() => remove(p)}>Futa</button>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

// ══ MATUKIO ═══════════════════════════════════════════════════════════
const EMPTY_EVENT = {
  name: '', type: 'mashindano', clubId: '', clubName: '', category: 'classical',
  startDate: new Date().toISOString().split('T')[0],
  endDate: '', arbiterName: '', timeControl: '', venue: '', bootstrap: false,
};

function EventsTab({ events, players, clubs, reload, flash, setErr, isAdmin, navigate }) {
  const [form, setForm] = useState(EMPTY_EVENT);
  const [editing, setEditing] = useState(null);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(null);
  const [games, setGames] = useState([]);
  const [busy, setBusy] = useState(false);
  const [g, setG] = useState({ whiteId: '', blackId: '', result: '1-0' });

  function ch(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function submit() {
    if (!form.name.trim()) { setErr('Andika jina la tukio.'); return; }
    setBusy(true); setErr('');
    try {
      const club = clubs.find(c => c.id === form.clubId);
      await saveEvent({
        ...form,
        clubName: club?.name || '',
        periodKey: periodKeyOf(new Date(form.startDate)),
      }, editing);
      flash(editing ? 'Tukio limebadilishwa.' : 'Tukio limesajiliwa.');
      setForm(EMPTY_EVENT); setEditing(null); setShow(false); reload();
    } catch (e) { console.error(e); setErr('Imeshindikana kuhifadhi.'); }
    setBusy(false);
  }

  async function openEvent(ev) {
    if (open?.id === ev.id) { setOpen(null); return; }
    setOpen(ev);
    try { setGames(await fetchGames({ eventId: ev.id })); }
    catch (e) { console.error(e); }
  }

  async function submitGame() {
    if (!g.whiteId || !g.blackId) { setErr('Chagua wachezaji wote wawili.'); return; }
    if (g.whiteId === g.blackId) { setErr('Mchezaji hawezi kucheza na nafsi yake.'); return; }
    setBusy(true); setErr('');
    try {
      const w = players.find(p => p.id === g.whiteId);
      const b = players.find(p => p.id === g.blackId);
      await addGame({
        eventId: open.id,
        eventName: open.name,
        periodKey: open.periodKey,
        whiteId: g.whiteId, whiteName: w.fullName,
        blackId: g.blackId, blackName: b.fullName,
        whiteRatingBefore: w.established ? w.ifr : null,
        blackRatingBefore: b.established ? b.ifr : null,
        result: g.result,
        rated: false,
      });
      setG({ whiteId: '', blackId: '', result: '1-0' });
      setGames(await fetchGames({ eventId: open.id }));
      flash('Mchezo umeongezwa.');
    } catch (e) { console.error(e); setErr('Imeshindikana kuongeza mchezo.'); }
    setBusy(false);
  }

  async function removeGame(id) {
    if (!window.confirm('Futa mchezo huu?')) return;
    try { await deleteGame(id); setGames(await fetchGames({ eventId: open.id })); }
    catch (e) { console.error(e); }
  }

  async function removeEvent(ev) {
    if (ev.status === 'rated') { setErr('Tukio lililokwisha kupimwa haliwezi kufutwa.'); return; }
    if (!window.confirm(`Futa tukio "${ev.name}" pamoja na michezo yake?`)) return;
    try { await deleteEvent(ev.id); setOpen(null); reload(); } catch (e) { console.error(e); }
  }

  return (
    <>
      <div
        onClick={() => navigate('/rating/live')}
        style={{
          display: 'flex', alignItems: 'center', gap: '11px', cursor: 'pointer',
          background: 'linear-gradient(135deg, #14452F, #1F6B45)', color: '#fff',
          borderRadius: '14px', padding: '15px 17px', marginBottom: '16px',
        }}
      >
        <Icon name="sparkle" size={18} color="#fff" />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '13.5px', fontWeight: 800 }}>Tukio la Papo Hapo</div>
          <div style={{ fontSize: '11.5px', opacity: 0.85, marginTop: '2px' }}>
            Simamia mashindano hadi mshindi — Swiss/Round Robin/Knockout, pairing kiotomatiki
          </div>
        </div>
        <span>→</span>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
        <div style={{ fontSize: '13px', color: '#6B7280' }}>Matukio {events.length}</div>
        <button style={{ ...RS.btn, padding: '11px 18px' }}
          onClick={() => { setShow(!show); setEditing(null); setForm(EMPTY_EVENT); }}>
          {show ? 'Funga' : '+ Tukio'}
        </button>
      </div>

      {show && (
        <div style={RS.card}>
          <h2 style={RS.h2}>{editing ? 'Badilisha tukio' : 'Sajili tukio rasmi'}</h2>

          <label style={RS.label}>Jina la tukio *</label>
          <input style={{ ...RS.input, marginBottom: '14px' }} value={form.name}
            onChange={e => ch('name', e.target.value)} placeholder="mf. Mashindano ya Arusha Julai 2026" />

          <label style={RS.label}>Kasi</label>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '14px', flexWrap: 'wrap' }}>
            {RATING_CATEGORIES.map(c => (
              <button key={c.key} type="button" onClick={() => ch('category', c.key)} style={{
                flex: '1 1 90px', padding: '9px', borderRadius: '10px', cursor: 'pointer',
                border: `1px solid ${form.category === c.key ? c.color : '#E8E4DA'}`,
                background: form.category === c.key ? c.color : '#fff',
                color: form.category === c.key ? '#fff' : '#6B7280',
                fontSize: '12px', fontWeight: 700, fontFamily: 'inherit',
              }}>{c.label}</button>
            ))}
          </div>

          <label style={RS.label}>Club inayoandaa</label>
          <select style={{ ...RS.input, marginBottom: '14px' }} value={form.clubId}
            onChange={e => ch('clubId', e.target.value)}>
            <option value="">—</option>
            {clubs.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 140px' }}>
              <label style={RS.label}>Tarehe ya kuanza *</label>
              <input type="date" style={{ ...RS.input, marginBottom: '14px' }} value={form.startDate}
                onChange={e => ch('startDate', e.target.value)} />
            </div>
            <div style={{ flex: '1 1 140px' }}>
              <label style={RS.label}>Tarehe ya kumaliza</label>
              <input type="date" style={{ ...RS.input, marginBottom: '14px' }} value={form.endDate}
                onChange={e => ch('endDate', e.target.value)} />
            </div>
          </div>

          <label style={RS.label}>Arbiter / msimamizi *</label>
          <input style={{ ...RS.input, marginBottom: '14px' }} value={form.arbiterName}
            onChange={e => ch('arbiterName', e.target.value)} />

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 140px' }}>
              <label style={RS.label}>Muda wa mchezo</label>
              <input style={{ ...RS.input, marginBottom: '14px' }} value={form.timeControl}
                onChange={e => ch('timeControl', e.target.value)} placeholder="mf. 60+30" />
            </div>
            <div style={{ flex: '1 1 140px' }}>
              <label style={RS.label}>Mahali</label>
              <input style={{ ...RS.input, marginBottom: '14px' }} value={form.venue}
                onChange={e => ch('venue', e.target.value)} />
            </div>
          </div>

          <label style={{ display: 'flex', alignItems: 'flex-start', gap: '9px', cursor: 'pointer', fontSize: '13px', color: '#374151', marginBottom: '8px' }}>
            <input type="checkbox" checked={form.bootstrap}
              onChange={e => ch('bootstrap', e.target.checked)}
              style={{ width: '17px', height: '17px', marginTop: '2px' }} />
            <span>Tukio la msingi (hakuna mchezaji mwenye rating)</span>
          </label>
          <div style={{ fontSize: '11.5px', color: '#92400E', background: '#FFFBEB', border: '1px solid #FDE68A', padding: '11px', borderRadius: '10px', marginBottom: '18px', lineHeight: 1.7 }}>
            Tumia hii <strong>mara moja tu</strong> kwa kikundi kipya kisicho na
            rating yoyote. Kila mtu atahesabiwa kama 1200 na atapata rating yake
            ya kwanza. Tukio la msingi <strong>haliwezi kutoa norm wala title</strong>.
          </div>

          <button style={{ ...RS.btn, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
            {busy ? 'Inahifadhi…' : editing ? 'Hifadhi' : 'Sajili tukio'}
          </button>
        </div>
      )}

      {events.length === 0 ? (
        <div style={RS.empty}>Bado hakuna tukio rasmi.</div>
      ) : events.map(ev => (
        <div key={ev.id} style={{ ...RS.card, padding: 0, overflow: 'hidden' }}>
          <div onClick={() => openEvent(ev)} style={{ padding: '15px 18px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '11px' }}>
            <div style={{
              width: '34px', height: '34px', borderRadius: '10px', flexShrink: 0,
              background: ev.status === 'rated' ? '#ECFDF5' : '#FFFBEB',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Icon name={ev.status === 'rated' ? 'check' : 'clock'} size={15}
                color={ev.status === 'rated' ? '#059669' : '#D97706'} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '14px', fontWeight: 700, color: '#1A1A1A' }}>
                {ev.name}{ev.bootstrap && <span style={{ ...RS.badge, background: '#FEF3C7', color: '#92400E', marginLeft: '7px' }}>MSINGI</span>}
                <span style={{ ...RS.badge, background: `${categoryInfo(ev.category).color}18`, color: categoryInfo(ev.category).color, marginLeft: '7px' }}>
                  {categoryInfo(ev.category).shortLabel}
                </span>
              </div>
              <div style={{ fontSize: '11.5px', color: '#6B7280', marginTop: '3px' }}>
                {ev.startDate} · {periodLabel(ev.periodKey)} · {ev.status === 'rated' ? 'imepimwa' : 'bado'}
                {ev.clubName ? ` · ${ev.clubName}` : ''}
              </div>
            </div>
            <span style={{ color: '#9CA3AF' }}>›</span>
          </div>

          {open?.id === ev.id && (
            <div style={{ padding: '0 18px 18px', borderTop: '1px solid #E8E4DA' }}>
              <div style={{ paddingTop: '15px' }}>
                <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '13px', lineHeight: 1.7 }}>
                  Arbiter: <strong>{ev.arbiterName || '—'}</strong>
                  {ev.timeControl ? ` · muda ${ev.timeControl}` : ''}
                  {ev.venue ? ` · ${ev.venue}` : ''}
                </div>

                {ev.status !== 'rated' && (
                  <div style={{ background: '#FAF8F3', padding: '14px', borderRadius: '12px', marginBottom: '14px' }}>
                    <div style={{ fontSize: '12.5px', fontWeight: 800, color: '#14452F', marginBottom: '11px' }}>
                      Ongeza mchezo
                    </div>
                    <select style={{ ...RS.input, marginBottom: '9px' }} value={g.whiteId}
                      onChange={e => setG({ ...g, whiteId: e.target.value })}>
                      <option value="">— Mweupe —</option>
                      <PlayerOptions players={players} suffix={p => p.established ? ` (${p.ifr})` : ' (bila rating)'} />
                    </select>
                    <select style={{ ...RS.input, marginBottom: '9px' }} value={g.blackId}
                      onChange={e => setG({ ...g, blackId: e.target.value })}>
                      <option value="">— Mweusi —</option>
                      <PlayerOptions players={players} suffix={p => p.established ? ` (${p.ifr})` : ' (bila rating)'} />
                    </select>
                    <div style={{ display: 'flex', gap: '7px', marginBottom: '11px' }}>
                      {[
                        { v: '1-0', l: 'Mweupe' },
                        { v: '½-½', l: 'Sare' },
                        { v: '0-1', l: 'Mweusi' },
                      ].map(o => (
                        <button key={o.v} onClick={() => setG({ ...g, result: o.v })} style={{
                          flex: 1, padding: '10px', borderRadius: '9px', cursor: 'pointer',
                          border: `1px solid ${g.result === o.v ? '#14452F' : '#E8E4DA'}`,
                          background: g.result === o.v ? '#14452F' : '#fff',
                          color: g.result === o.v ? '#fff' : '#6B7280',
                          fontSize: '12px', fontWeight: 700, fontFamily: 'inherit',
                        }}>{o.l}</button>
                      ))}
                    </div>
                    <button style={{ ...RS.btn, width: '100%', opacity: busy ? 0.6 : 1 }}
                      disabled={busy} onClick={submitGame}>Ongeza</button>
                  </div>
                )}

                <div style={{ fontSize: '12.5px', fontWeight: 800, color: '#14452F', marginBottom: '9px' }}>
                  Michezo ({games.length})
                </div>
                {games.length === 0 ? (
                  <div style={{ fontSize: '12.5px', color: '#6B7280' }}>Bado hakuna mchezo.</div>
                ) : games.map(x => (
                  <div key={x.id} style={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    padding: '10px 0', borderTop: '1px solid #F3F1EB', fontSize: '12.5px',
                  }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <span style={{ fontWeight: 600 }}>{x.whiteName}</span>
                      <span style={{ color: '#9CA3AF', margin: '0 6px' }}>{x.result}</span>
                      <span style={{ fontWeight: 600 }}>{x.blackName}</span>
                    </div>
                    {ev.status !== 'rated' && (
                      <button style={{ ...RS.btnGhost, padding: '4px 9px', fontSize: '10.5px', color: '#DC2626' }}
                        onClick={() => removeGame(x.id)}>Futa</button>
                    )}
                  </div>
                ))}

                {isAdmin && ev.status !== 'rated' && (
                  <div style={{ display: 'flex', gap: '8px', marginTop: '15px' }}>
                    <button style={{ ...RS.btnGhost, fontSize: '11.5px', padding: '8px 14px' }}
                      onClick={() => { setForm({ ...EMPTY_EVENT, ...ev }); setEditing(ev.id); setShow(true); window.scrollTo(0, 0); }}>
                      Hariri tukio
                    </button>
                    <button style={{ ...RS.btnGhost, fontSize: '11.5px', padding: '8px 14px', color: '#DC2626' }}
                      onClick={() => removeEvent(ev)}>Futa tukio</button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
}

// ══ KUCHAPISHA ════════════════════════════════════════════════════════
function PublishTab({ players, events, reload, flash, setErr, currentUser, isAdmin }) {
  const [periodKey, setPeriodKey] = useState(periodKeyOf());
  const [preview, setPreview] = useState(null); // { classical: {...}, rapid: {...}, blitz: {...} }
  const [cat, setCat] = useState('classical');
  const [busy, setBusy] = useState(false);
  const [published, setPublished] = useState([]);
  const [log, setLog] = useState([]);

  useEffect(() => { fetchPeriods().then(setPublished).catch(console.error); }, []);

  const options = Array.from(new Set(events.map(e => e.periodKey).filter(Boolean))).sort().reverse();
  const already = published.find(p => p.id === periodKey);
  const pending = events.filter(e => e.periodKey === periodKey && e.status !== 'rated');

  async function runPreview() {
    setBusy(true); setErr('');
    try {
      const games = await fetchGames();
      setPreview(computePeriod({ periodKey, players, events, games }));
    } catch (e) { console.error(e); setErr('Imeshindikana kuhesabu.'); }
    setBusy(false);
  }

  async function doPublish() {
    if (!window.confirm(`Chapisha rating za ${periodLabel(periodKey)} — kasi zote tatu (Classical, Rapid, Blitz)? Hii itabadilisha rating rasmi za wachezaji wote waliocheza.`)) return;
    setBusy(true); setErr('');
    try {
      const name = await resolveAuthorName(currentUser);
      await publishPeriod({ periodKey, author: { uid: currentUser.uid, name } });
      flash(`Rating za ${periodLabel(periodKey)} zimechapishwa (kasi zote tatu).`);
      setPreview(null);
      setPublished(await fetchPeriods());
      reload();
    } catch (e) { console.error(e); setErr('Imeshindikana kuchapisha.'); }
    setBusy(false);
  }

  async function doRecompute() {
    if (!window.confirm('Hesabu upya rating ZOTE kutoka mwanzo (kasi zote tatu)? Hii inatumia michezo yote iliyohifadhiwa. Matokeo yatakuwa yaleyale isipokuwa kanuni zimebadilika.')) return;
    setBusy(true); setErr(''); setLog([]);
    try {
      const name = await resolveAuthorName(currentUser);
      const out = await recomputeAll({
        author: { name },
        onProgress: line => setLog(l => [...l, line]),
      });
      flash(`Imekamilika — vipindi ${out.periods.length}, wachezaji ${out.players}.`);
      reload();
    } catch (e) { console.error(e); setErr('Imeshindikana kuhesabu upya.'); }
    setBusy(false);
  }

  const catInfo = categoryInfo(cat);
  const catPreview = preview?.[cat];

  return (
    <>
      <div style={RS.card}>
        <h2 style={RS.h2}>Chagua kipindi</h2>
        <select style={{ ...RS.input, marginBottom: '14px' }} value={periodKey}
          onChange={e => { setPeriodKey(e.target.value); setPreview(null); }}>
          {options.length === 0 && <option value={periodKey}>{periodLabel(periodKey)}</option>}
          {options.map(k => <option key={k} value={k}>{periodLabel(k)}</option>)}
        </select>

        <div style={{ fontSize: '12.5px', color: '#6B7280', lineHeight: 1.8, marginBottom: '16px' }}>
          Matukio yasiyopimwa: <strong style={{ color: '#1A1A1A' }}>{pending.length}</strong>
          {already && <><br />Kipindi hiki kilishachapishwa {periodLabel(periodKey)}.</>}
        </div>

        <div style={{ display: 'flex', gap: '9px', flexWrap: 'wrap' }}>
          <button style={{ ...RS.btnGhost, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={runPreview}>
            {busy ? 'Inahesabu…' : 'Hakiki kwanza (kasi zote tatu)'}
          </button>
          {isAdmin && (
            <button style={{ ...RS.btn, opacity: busy || !preview ? 0.5 : 1 }}
              disabled={busy || !preview} onClick={doPublish}>
              Chapisha Zote Tatu
            </button>
          )}
        </div>
        {!preview && (
          <div style={{ fontSize: '11.5px', color: '#6B7280', marginTop: '11px' }}>
            Lazima uhakiki kwanza kabla ya kuchapisha.
          </div>
        )}
      </div>

      {preview && (
        <>
          <div style={{ display: 'flex', gap: '7px', marginBottom: '14px' }}>
            {RATING_CATEGORIES.map(c => (
              <button key={c.key} onClick={() => setCat(c.key)} style={{
                flex: 1, padding: '10px', borderRadius: '11px', cursor: 'pointer',
                border: `1px solid ${cat === c.key ? c.color : '#E8E4DA'}`,
                background: cat === c.key ? c.color : '#fff', color: cat === c.key ? '#fff' : '#6B7280',
                fontSize: '12.5px', fontWeight: 700, fontFamily: 'inherit',
              }}>
                {c.label} ({preview[c.key].results.length})
              </button>
            ))}
          </div>

          <div style={RS.card}>
            <h2 style={RS.h2}>Hakiki — {catInfo.label} · {periodLabel(periodKey)}</h2>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '16px' }}>
              <Mini value={catPreview.events.length} label="Matukio" />
              <Mini value={catPreview.gamesCount} label="Michezo" />
              <Mini value={catPreview.results.length} label="Wachezaji" />
              {cat === 'classical' && <Mini value={catPreview.normAwards.length} label="Norms" color="#7C3AED" />}
              {cat === 'classical' && <Mini value={catPreview.titleAwards.length} label="Titles" color="#B45309" />}
            </div>

            {catPreview.results.length === 0 && (
              <div style={{ fontSize: '13px', color: '#6B7280' }}>
                Hakuna mchezo wa {catInfo.label} unaohesabika kwenye kipindi hiki.
              </div>
            )}

            {catPreview.results.map(r => (
              <div key={r.playerId} style={{
                display: 'flex', alignItems: 'center', gap: '11px',
                padding: '11px 0', borderTop: '1px solid #F3F1EB',
              }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '13.5px', fontWeight: 700, color: '#1A1A1A' }}>{r.name}</div>
                  <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>
                    {r.kind === 'initial' ? `Rating ya kwanza (performance ${r.performance})`
                      : r.kind === 'pending' ? r.reason
                        : `Michezo ${r.games.length} · K=${r.k}`}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  {r.after ? (
                    <>
                      <div style={{ fontSize: '16px', fontWeight: 800, color: '#14452F' }}>{r.after}</div>
                      {r.before !== null && r.before !== undefined && (
                        <div style={{
                          fontSize: '11px', fontWeight: 700,
                          color: r.change > 0 ? '#059669' : r.change < 0 ? '#DC2626' : '#9CA3AF',
                        }}>
                          {r.before} → {r.change > 0 ? '+' : ''}{r.change}
                        </div>
                      )}
                    </>
                  ) : (
                    <div style={{ fontSize: '12px', color: '#D97706', fontWeight: 700 }}>bado</div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {cat === 'classical' && catPreview.normAwards.length > 0 && (
            <div style={RS.card}>
              <h2 style={RS.h2}>Norms mpya</h2>
              {catPreview.normAwards.map((n, i) => (
                <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '10px 0', borderTop: i ? '1px solid #F3F1EB' : 'none' }}>
                  <TitleBadge code={n.title} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: 700 }}>{n.playerName}</div>
                    <div style={{ fontSize: '11px', color: '#6B7280' }}>
                      {n.eventName} · performance {n.performance} · wastani wa wapinzani {n.avgOpponent}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {cat === 'classical' && catPreview.titleAwards.length > 0 && (
            <div style={RS.card}>
              <h2 style={RS.h2}>Titles mpya</h2>
              {catPreview.titleAwards.map((t, i) => (
                <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '10px 0', borderTop: i ? '1px solid #F3F1EB' : 'none' }}>
                  <TitleBadge code={t.title} size="lg" />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13.5px', fontWeight: 700 }}>{t.playerName}</div>
                    <div style={{ fontSize: '11px', color: '#6B7280' }}>
                      {titleByCode(t.title)?.name} · rating {t.rating}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {cat !== 'classical' && (
            <div style={{ ...RS.card, background: '#FAF8F3', fontSize: '11.5px', color: '#6B7280' }}>
              {catInfo.label} haina Titles wala norms — kama FIDE, hizo ni za Classical pekee.
            </div>
          )}
        </>
      )}

      {isAdmin && (
        <div style={{ ...RS.card, border: '1px solid #FDE68A', background: '#FFFBEB' }}>
          <h2 style={{ ...RS.h2, color: '#92400E' }}>Hesabu upya kila kitu</h2>
          <div style={{ fontSize: '12.5px', color: '#92400E', lineHeight: 1.8, marginBottom: '15px' }}>
            Inafuta rating zote na kuzihesabu upya kutoka mchezo wa kwanza kabisa,
            kipindi kwa kipindi. Tumia hii ukibadilisha kanuni au ukigundua hitilafu.
            Michezo haiguswi — ndio maana hii ni salama.
          </div>
          <button style={{ ...RS.btn, background: '#92400E', opacity: busy ? 0.6 : 1 }}
            disabled={busy} onClick={doRecompute}>
            {busy ? 'Inahesabu…' : 'Hesabu upya'}
          </button>
          {log.length > 0 && (
            <div style={{ marginTop: '14px', fontSize: '11.5px', color: '#92400E', lineHeight: 1.8 }}>
              {log.map((l, i) => <div key={i}>{l}</div>)}
            </div>
          )}
        </div>
      )}

      {published.length > 0 && (
        <div style={RS.card}>
          <h2 style={RS.h2}>Vipindi vilivyochapishwa</h2>
          {published.map(p => (
            <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderTop: '1px solid #F3F1EB', fontSize: '12.5px' }}>
              <div>
                <div style={{ fontWeight: 700, color: '#1A1A1A' }}>{periodLabel(p.periodKey)}</div>
                <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>
                  na {p.publishedByName || '—'}
                </div>
              </div>
              <div style={{ textAlign: 'right', color: '#6B7280' }}>
                michezo {p.gamesCount} · wachezaji {p.playersUpdated}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

function Mini({ value, label, color = '#14452F' }) {
  return (
    <div style={{ background: `${color}0F`, borderRadius: '10px', padding: '9px 13px', minWidth: '74px' }}>
      <div style={{ fontSize: '18px', fontWeight: 800, color, lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: '10.5px', color: '#6B7280', marginTop: '3px' }}>{label}</div>
    </div>
  );
}

// ══ MAKOCHA ═══════════════════════════════════════════════════════════
const EMPTY_COACH = {
  name: '', staffUid: '', clubNames: '', yearsActive: 0,
  certifications: [], studentIds: [],
};

function CoachesTab({ players, clubs, flash, setErr, isAdmin }) {
  const [coaches, setCoaches] = useState([]);
  const [form, setForm] = useState(EMPTY_COACH);
  const [editing, setEditing] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(null);
  const [certInput, setCertInput] = useState('');

  useEffect(() => { load(); }, []);
  async function load() {
    try { setCoaches(await fetchCoaches()); } catch (e) { console.error(e); }
  }

  function ch(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function submit() {
    if (!form.name.trim()) { setErr('Andika jina la kocha.'); return; }
    setBusy(true); setErr('');
    try {
      await saveCoach({ ...form, yearsActive: Number(form.yearsActive) || 0 }, editing);
      flash(editing ? 'Kocha amebadilishwa.' : 'Kocha amesajiliwa.');
      setForm(EMPTY_COACH); setEditing(null); setShow(false); load();
    } catch (e) { console.error(e); setErr('Imeshindikana kuhifadhi.'); }
    setBusy(false);
  }

  // Hesabu IFC kutokana na data halisi: wanafunzi + ripoti za session
  async function recompute(c) {
    setBusy(true); setErr('');
    try {
      const sessions = await fetchReports({ kind: 'session' });
      const mine = sessions.filter(s => s.authorId === c.staffUid);
      const totals = mine.reduce((a, s) => ({
        present: a.present + (s.presentCount || 0),
        total: a.total + (s.totalCount || 0),
      }), { present: 0, total: 0 });
      const attendanceRate = totals.total ? Math.round((totals.present / totals.total) * 100) : 0;

      const rec = computeCoachRecord(c, {
        students: players,
        sessions: mine.length,
        attendanceRate,
      });

      await saveCoach({
        ifc: rec.ifc,
        title: rec.title,
        inputs: rec.inputs,
        studentsRated: rec.studentsRated,
        titledStudents: rec.titledStudents,
        computedAt: new Date().toISOString(),
      }, c.id);
      flash(`IFC ya ${c.name} imehesabiwa: ${rec.ifc}`);
      load();
    } catch (e) { console.error(e); setErr('Imeshindikana kuhesabu IFC.'); }
    setBusy(false);
  }

  function toggleStudent(id) {
    setForm(f => {
      const list = f.studentIds || [];
      return { ...f, studentIds: list.includes(id) ? list.filter(x => x !== id) : [...list, id] };
    });
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
        <div style={{ fontSize: '13px', color: '#6B7280' }}>Makocha {coaches.length}</div>
        <button style={{ ...RS.btn, padding: '11px 18px' }}
          onClick={() => { setShow(!show); setEditing(null); setForm(EMPTY_COACH); }}>
          {show ? 'Funga' : '+ Kocha'}
        </button>
      </div>

      {show && (
        <div style={RS.card}>
          <h2 style={RS.h2}>{editing ? 'Badilisha kocha' : 'Sajili kocha'}</h2>

          <label style={RS.label}>Jina kamili *</label>
          <input style={{ ...RS.input, marginBottom: '14px' }} value={form.name}
            onChange={e => ch('name', e.target.value)} />

          <label style={RS.label}>Kitambulisho cha staff (UID)</label>
          <input style={{ ...RS.input, marginBottom: '6px' }} value={form.staffUid}
            onChange={e => ch('staffUid', e.target.value)} placeholder="UID ya akaunti yake ya staff" />
          <div style={{ fontSize: '11.5px', color: '#6B7280', marginBottom: '14px', lineHeight: 1.6 }}>
            Hii inaunganisha kocha na ripoti zake za session — ndipo idadi ya
            session na mahudhurio yanakotoka.
          </div>

          <label style={RS.label}>Vilabu anavyofundisha</label>
          <input style={{ ...RS.input, marginBottom: '14px' }} value={form.clubNames}
            onChange={e => ch('clubNames', e.target.value)}
            placeholder={clubs.slice(0, 2).map(c => c.name).join(', ') || 'Majina ya vilabu'} />

          <label style={RS.label}>Miaka ya utumishi</label>
          <input type="number" style={{ ...RS.input, marginBottom: '14px' }} value={form.yearsActive}
            onChange={e => ch('yearsActive', e.target.value)} />

          <label style={RS.label}>Vyeti / mafunzo</label>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '9px' }}>
            <input style={{ ...RS.input, flex: 1 }} value={certInput}
              onChange={e => setCertInput(e.target.value)} placeholder="mf. FIDE School Instructor" />
            <button style={{ ...RS.btnGhost }} onClick={() => {
              if (!certInput.trim()) return;
              ch('certifications', [...(form.certifications || []), certInput.trim()]);
              setCertInput('');
            }}>Ongeza</button>
          </div>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '16px' }}>
            {(form.certifications || []).map((c, i) => (
              <span key={i} style={{ ...RS.badge, background: '#EFF6FF', color: '#1D4ED8', fontSize: '11px', padding: '5px 9px' }}
                onClick={() => ch('certifications', form.certifications.filter((_, j) => j !== i))}>
                {c} ✕
              </span>
            ))}
          </div>

          <label style={RS.label}>Wanafunzi wake ({(form.studentIds || []).length})</label>
          <div style={{ maxHeight: '190px', overflowY: 'auto', border: '1px solid #E8E4DA', borderRadius: '11px', padding: '10px', marginBottom: '18px' }}>
            {players.length === 0 ? (
              <div style={{ fontSize: '12.5px', color: '#6B7280' }}>Hakuna mchezaji aliyesajiliwa bado.</div>
            ) : groupByClub(players).map(group => (
              <div key={group.clubName} style={{ marginBottom: '9px' }}>
                <div style={{ fontSize: '10px', fontWeight: 800, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.4px', margin: '6px 0 3px' }}>
                  {group.clubName}
                </div>
                {group.members.map(p => (
                  <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '6px 0', cursor: 'pointer', fontSize: '12.5px' }}>
                    <input type="checkbox" checked={(form.studentIds || []).includes(p.id)}
                      onChange={() => toggleStudent(p.id)} />
                    {p.fullName} {p.established ? `(${p.ifr})` : ''}
                  </label>
                ))}
              </div>
            ))}
          </div>

          <button style={{ ...RS.btn, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
            {busy ? 'Inahifadhi…' : editing ? 'Hifadhi' : 'Sajili'}
          </button>
        </div>
      )}

      {coaches.length === 0 ? (
        <div style={RS.empty}>Bado hakuna kocha kwenye IFC.</div>
      ) : coaches.map(c => {
        const t = COACH_TITLES.find(x => x.code === c.title);
        const isOpen = open === c.id;
        return (
          <div key={c.id} style={{ ...RS.card, padding: 0, overflow: 'hidden' }}>
            <div onClick={() => setOpen(isOpen ? null : c.id)}
              style={{ padding: '15px 18px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '11px' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexWrap: 'wrap' }}>
                  {t && <span style={{ ...RS.badge, background: `${t.color}18`, color: t.color }}>{t.code}</span>}
                  <span style={{ fontSize: '14px', fontWeight: 700, color: '#1A1A1A' }}>{c.name}</span>
                </div>
                <div style={{ fontSize: '11.5px', color: '#6B7280', marginTop: '3px' }}>
                  {c.clubNames || '—'} · wanafunzi {c.studentsRated || 0}
                  {c.titledStudents ? ` · title ${c.titledStudents}` : ''}
                </div>
              </div>
              <div style={{ fontSize: '18px', fontWeight: 800, color: '#14452F' }}>{c.ifc || '—'}</div>
              <span style={{ color: '#9CA3AF' }}>›</span>
            </div>

            {isOpen && (
              <div style={{ padding: '0 18px 18px', borderTop: '1px solid #E8E4DA' }}>
                <div style={{ paddingTop: '14px' }}>
                  {c.inputs ? Object.entries(c.inputs).map(([k, v]) => (
                    <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12.5px', padding: '6px 0', color: '#4B5563' }}>
                      <span>{k}</span><strong>{v}</strong>
                    </div>
                  )) : (
                    <div style={{ fontSize: '12.5px', color: '#6B7280' }}>
                      IFC bado haijahesabiwa kwa kocha huyu.
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: '8px', marginTop: '14px', flexWrap: 'wrap' }}>
                    <button style={{ ...RS.btn, padding: '10px 16px', fontSize: '12.5px', opacity: busy ? 0.6 : 1 }}
                      disabled={busy} onClick={() => recompute(c)}>
                      Hesabu IFC upya
                    </button>
                    <button style={{ ...RS.btnGhost, padding: '10px 16px', fontSize: '12.5px' }}
                      onClick={() => { setForm({ ...EMPTY_COACH, ...c }); setEditing(c.id); setShow(true); window.scrollTo(0, 0); }}>
                      Hariri
                    </button>
                    {isAdmin && (
                      <button style={{ ...RS.btnGhost, padding: '10px 16px', fontSize: '12.5px', color: '#DC2626' }}
                        onClick={async () => {
                          if (!window.confirm(`Futa ${c.name}?`)) return;
                          await deleteCoach(c.id); load();
                        }}>Futa</button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}

      <div style={{ ...RS.card, background: '#FAF8F3', fontSize: '12px', color: '#6B7280', lineHeight: 1.8 }}>
        <Icon name="info" size={13} color="#E07A2E" /> IFC inahesabiwa kutokana na
        data halisi: wanafunzi waliopimwa, ongezeko lao la rating, title zao, na
        ripoti za session zilizoandikwa kwenye programu. Uzito wa kila kipengele
        umechapishwa hadharani kwenye ukurasa wa mfumo.
      </div>
    </>
  );
}

export { PLAYER_TITLES };
